// import CodeMirror from ".CodeMirror"

export default function CodeEditeur(props){
    const meRef = useRef(null)


    useEffect( ()=>{
console.log("Initialisation d'un editeur")
console.log(myRef.current)
    } ,[])

    return (
        <>
         <div ref={myRef} id="codeMirror">
        {props.children}
         </div>

        </>
    )
}
